import {
    AnyPcbBakedNode,
    EditorModes,
    INetsMap,
    PcbNode,
    PcbNodeTypes,
    PcbNodesMap,
    createActionRecordAction,
} from "@buildwithflux/core";
import {AppThunkAction} from "storeTypes";

import {getAllBakedNodes} from "modules/stores/pcb/utils";

import {getUpdatedElementNodePositions} from "./addRouteSegment";

export const addPolygon = createActionRecordAction(
    "addPolygon",
    (
        node: PcbNode<PcbNodeTypes.polygon>,
        editorMode: EditorModes,
        documentNets: INetsMap,
        pcbLayoutNodes: PcbNodesMap<AnyPcbBakedNode>,
    ) => {
        // When adding a polygon we don't know what's going to be connected
        // To be safe, we fix the position of all pins in the net
        const nodeNet = node.parentUid;
        const allPinsInNet = Object.keys(documentNets[nodeNet]?.pins ?? {});
        const updatedNodePositions = getUpdatedElementNodePositions(allPinsInNet, pcbLayoutNodes);

        return {
            payload: {
                node,
                updatedNodePositions,
                canUndo: true,
                inPcbEditor: editorMode === EditorModes.pcb,
                updatesDocumentTimestamp: true,
                shouldGenerateActionRecord: true,
            },
        };
    },
    "added PCB polygon",
);

export function addPolygonThunk(node: PcbNode<PcbNodeTypes.polygon>): AppThunkAction<void> {
    return (_dispatch, _getState, services) => {
        // Get document from Zustand store instead of Redux state
        const document = services.documentStore.getState().document;
        if (!document) {
            throw new Error("Document not found in state");
        }

        const {editorMode} = services.usePersistedDocumentUiStore.getState();
        const pcbLayoutNodes = getAllBakedNodes(services.documentService);
        // Dispatch directly to Zustand (bypassing Redux middleware bridge)
        const nodeNet = node.parentUid;
        const allPinsInNet = Object.keys(document.nets[nodeNet]?.pins ?? {});
        const updatedNodePositions = getUpdatedElementNodePositions(allPinsInNet, pcbLayoutNodes);
        services.documentStore.getState().addPolygon(node, updatedNodePositions, editorMode === EditorModes.pcb);
    };
}
